import { HEADER_HEIGHT } from '../../../model/table';

/* Default level for an item in the table hierarchy.
 * When hierarchy information is absent, a flat table should display items at this level.
 */
export const DEFAULT_LEVEL = 1;

// Amount that window resize event handlers should be debounced by
export const RESIZE_DEBOUNCE_MS = 250;

// ============= //
// === SIZES === //
// ============= //

export const TABLE_HEADER_HEIGHT_PX = `${HEADER_HEIGHT}px`;
export const HIDE_SCROLLBAR_OFFSET_PX = '50px';

// A bar *can* be smaller than this, but requires special handling when it is
export const MINIMUM_BAR_LENGTH = 36;

// number of hours to show for each column in day view
export const DAY_VIEW_COLUMN_HOUR_INTERVAL = 2;
